var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 44.5,
    r: 44.5,
    fill: "#105B3D",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9788 27.7451C54.3851 27.9022 53.6491 28.6588 53.4908 29.2747C53.2515 30.2062 53.6523 31.1592 54.4853 31.6389C54.9661 31.916 55.0024 31.9205 57.1088 31.9704L59.2448 32.021L53.1528 38.8987C49.8021 42.6815 46.9985 45.8393 46.9225 45.916C46.8059 46.0336 46.3774 45.669 44.1883 43.5897C42.7605 42.2335 41.4048 41.0142 41.1757 40.8802C40.6261 40.5585 39.7641 40.536 39.1797 40.8279C38.8714 40.9818 36.7713 43.263 30.8938 49.828C26.5636 54.6646 22.8983 58.8204 22.7484 59.0629C22.1889 59.9691 22.4856 61.2103 23.4145 61.8493C24.0055 62.2559 24.9575 62.3356 25.5627 62.0291C26.1158 61.7489 26.0697 61.7988 33.5494 53.3876C37.1979 49.285 40.2152 45.9283 40.2545 45.9283C40.2939 45.9283 41.4849 47.0727 42.9013 48.4713C45.62 51.1564 45.9225 51.3839 46.7806 51.3878C47.8259 51.3927 47.7015 51.5152 55.2539 43.049L62.1984 35.2642L62.25 37.2411C62.2997 39.1415 62.3117 39.2322 62.5597 39.591C62.7016 39.7961 62.9996 40.0885 63.2219 40.2405C63.5767 40.4834 63.7224 40.5171 64.4177 40.5171C65.113 40.5171 65.2588 40.4834 65.6136 40.2405C65.8358 40.0885 66.1338 39.796 66.2757 39.5905L66.5338 39.217V34.1358V29.0546L66.2196 28.616C66.0467 28.3748 65.6983 28.0637 65.4454 27.9246L64.9855 27.6718L60.1856 27.6546C57.0593 27.6433 55.2438 27.6749 54.9788 27.7451Z",
    fill: "#105B3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrease);
export default __webpack_public_path__ + "static/media/increase.5d79a15c0ee1bbcc0b70d08cba466e21.svg";
export { ForwardRef as ReactComponent };